import "@mdi/font/css/materialdesignicons.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import fr from "vuetify/es5/locale/fr.js";

Vue.use(Vuetify);
export default new Vuetify({
  theme: {
    dark: false,
  },
  lang: {
    locales: { fr },
    current: "fr",
  },
});
